import { gql } from '@apollo/client';

export const SyncedProvidersFragment = gql`
  fragment SyncedProviders on SyncedProviders {
    id
    accountingProviders {
      id
      providerName
      originalSyncDate
    }
    payrollProviders {
      id
      providerName
      originalSyncDate
    }
    ticketingProviders {
      id
      providerName
      originalSyncDate
    }
  }
`;
